import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface KillSwitchConfirmDialogData {
  /** The target AI active state after confirm. true = resume calls, false = stop calls. */
  targetAiActive: boolean;
}

@Component({
  selector: 'app-kill-switch-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './kill-switch-confirm-dialog.component.html',
  styleUrl: './kill-switch-confirm-dialog.component.css'
})
export class KillSwitchConfirmDialogComponent {
  readonly targetAiActive: boolean;

  constructor(
    private readonly dialogRef: MatDialogRef<KillSwitchConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) data: KillSwitchConfirmDialogData
  ) {
    this.targetAiActive = !!data?.targetAiActive;
  }

  /** Stopping calls = targetAiActive is false. */
  get isStopping(): boolean {
    return !this.targetAiActive;
  }

  get title(): string {
    return this.isStopping
      ? 'Stop all AI outbound calls?'
      : 'Resume all AI outbound calls?';
  }

  get message(): string {
    return this.isStopping
      ? 'This will immediately halt new AI outbound calls across all pools. Ongoing calls will complete. Per-pool toggles will be disabled until you turn this back on.'
      : 'This will resume AI outbound calls across all pools. Per-pool toggles will be re-enabled.';
  }

  get confirmLabel(): string {
    return this.isStopping ? 'Turn off' : 'Turn on';
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
